import { mergeCopyrightLines, mergeInheritedLines } from 'utils/cms/utils';
import { getSeoFooterMessaging } from 'utils/seoFooterMessaging';
import { sortObjectByOrder } from 'utils/utils';

const currentYear = new Date().getFullYear();
// Hub site page IDs that can be selected as internal link targets in Nav & Legal.
// These need to be converted to absolute paths so they don't resolve as broken relative URLs on movie pages.
const HUB_PAGE_IDS = new Set(['landing', 'about', 'news', 'releases', 'leadership', 'contact', 'terms-of-use']);

function resolveDestination(destination) {
	if (!destination) return null;
	if (destination === 'cookies') return 'cookies';
	// Already a full URL
	if (/^(https?:)?\/\//.test(destination)) return destination;
	// TODO: We should not rely on the slug (could be localized for different regions)
	//   hub page ids should be added as external links
	if (HUB_PAGE_IDS.has(destination)) return `/${destination}/`;
	return destination;
}

function mapLinks(cmsData) {
	const navigationFooter = cmsData?.footer?._navigationFooter;
	const globalLinks = navigationFooter?.moviePageFooter?.links || navigationFooter?.legal || [];
	const mergedLinks = mergeInheritedLines(globalLinks, cmsData?.footer?.links);

	return mergedLinks.map(item => item && !item._hidden && ({
		$copy: item.name,
		url: resolveDestination(item.destination),
	})).filter(Boolean);
}

function mapLogos(cmsData) {
	return sortObjectByOrder(cmsData?.footer?.logos).map(item => item && ({ alt: item.name, src: item.url })).filter(Boolean);
}

function listLines(value) {
	if (Array.isArray(value)) return value;
	if (typeof value !== 'string') return [];
	return value.split('\n').map(a => a.trim());
}
function toCopyrightItem(data) {
	if (typeof data === 'string') data = { name: data };
	if (!data?.name) return null;
	return { $copy: data.name.replace(/\[YEAR\]/gi, currentYear), url: resolveDestination(data.destination) };
}
function mapCopyright(cmsData, appData) {
	const navigationFooter = cmsData?.footer?._navigationFooter;

	const copyright = [];
	const legalTextOverride = cmsData?.footer?.legalText;
	if (legalTextOverride) {
		copyright.push(toCopyrightItem(legalTextOverride));
	} else {
		const globalCopyright = listLines(navigationFooter?.moviePageFooter?.copyright || navigationFooter?.copyright);
		const mergedLines = mergeCopyrightLines(globalCopyright, cmsData?.footer?.copyright);
		copyright.push(...mergedLines.filter(e => !e._hidden).map(toCopyrightItem));
	}
	copyright.push(toCopyrightItem(cmsData?.footer?.seoMessaging || getSeoFooterMessaging(cmsData, appData?.copy?.baseCopy)));

	return copyright.filter(Boolean);
}

export default function mapFooter(cmsData, appData) {
	const result = {
		defaultFooter: {
			copyright: mapCopyright(cmsData, appData),
			links: mapLinks(cmsData),
			logos: mapLogos(cmsData),
		}
	};

	return result;
}